import { useTaskCalendarSyncControls } from '@griply/hooks';
import { Task } from '@griply/types';
import { useCalendarTaskSync } from 'features/external-connections';
import React, { useMemo } from 'react';
import { CalendarSyncMenuItems } from 'shared/components/ui/calendar-sync-menu';
import { PopupMenuList } from 'shared/components/ui/popup-menu';

export type TaskCalendarSyncListProps = {
  task: Task;
  onClose: () => void;
  onAction?: () => void;
};

export const TaskCalendarSyncList: React.FC<TaskCalendarSyncListProps> = ({
  task,
  onClose,
  onAction,
}) => {
  const tasks = useMemo(() => [task], [task]);
  const calendarSync = useCalendarTaskSync(tasks);
  const { syncState, toggleSync, toggleVisibility } =
    useTaskCalendarSyncControls(task, calendarSync);

  const onToggleSync = () => {
    toggleSync();
    onAction?.();
    onClose();
  };

  const onToggleVisibility = () => {
    toggleVisibility();
    onAction?.();
    onClose();
  };

  if (!syncState) {
    return null;
  }

  return (
    <PopupMenuList hasBottomBorder>
      <CalendarSyncMenuItems
        isSynced={syncState.isSynced}
        isHidden={syncState.isHidden}
        onToggleSync={onToggleSync}
        onToggleVisibility={onToggleVisibility}
      />
    </PopupMenuList>
  );
};
